import Vue from "vue";

export function registerDataset(appElement) {
  const ds = {
    buildVersion: process.env.VUE_APP_BUILD_VERSION || "",
    recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    isProductionLike: process.env.VUE_APP_IS_PRODUCTION_LIKE === "true",
    googleMapsApiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    placeOrderServiceUrl:
      process.env.VUE_APP_PLACE_ORDER_SERVICE_URL ||
      "http://localhost:8081/2015-03-31/functions/function/invocations",
    pdfServiceUrl:
      process.env.VUE_APP_PDF_SERVICE_URL || "https://pdf.test.aws.vcgs.org.au",
    isUploadConsentEnabled:
      process.env.VUE_APP_IS_UPLOAD_CONSENT_ENABLED === "true",
    isUploadPreviousReportEnabled:
      process.env.VUE_APP_IS_UPLOAD_PREVIOUS_REPORT_ENABLED === "true",
    environment: process.env.VUE_APP_ENVIRONMENT,
    externalCms: process.env.VUE_APP_EXTERNAL_CMS,
    uploadServiceApi: process.env.VUE_APP_UPLOAD_SERVICE_API,
  };

  // a variable that should be true *only* when we launch the website via npm run serve with no backend
  // this can be used to skip code that interacts with the backend APIs if needed for testing
  ds["isFrontEndOnly"] = !ds["buildVersion"] && !ds["isProductionLike"];

  // place the dataset #app values into a global property $dataset across all vue elements
  ds.install = function() {
    Object.defineProperty(Vue.prototype, "$dataset", {
      get() {
        return ds;
      },
      configurable: true,
    });
  };
  Vue.use(ds);

  // we also need some of these values in our startup so we return them even before
  // we use them in Vue
  return ds;
}
